import { Heading, Text, Flex, Button } from '@chakra-ui/react';
import { useHistory } from "react-router"
import React, {useEffect} from 'react';
import { Helmet } from "react-helmet";

export default function NotFound() {
  let history = useHistory();

  function handleClick() {
    history.goBack();
  }

  return (
    <Flex flexDirection="column" h="100vh" w="100%" justifyContent="center" alignItems="center">
      <Helmet>
        <title>Vidcom | 404</title>
        <meta name="description" content="page not found" />
      </Helmet>
      <Heading as="h1" fontWeight="700" fontStyle="normal" fontSize={{ base: "3rem", md: "6.5rem", lg: "9rem" }}>
        404
      </Heading>
      <Text
        fontSize="md"
        textTransform="capitalize"
        mt={{ base: "10px", md: "15px", lg: "40px" }}
        mb={{ base: "10px", md: "15px", lg: "50px" }}
      >
        page not found
        </Text>
      <Button
        onClick={handleClick}
        textTransform="capitalize"
        bgColor="#10B981"
        color="white"
        p={{base: "5px 30px", md: "5px 100px",  lg:"5px 150px"}}
        mt="10px"
        _hover={{color: "black"}}
      >
        go back
      </Button>
    </Flex>
  )
}
